import React from "react";
import { useRepaymentHelper } from "./useRepaymentHelper";
import { name } from "./constants";
import { useRepaymentFrequency } from "./useRepaymentFrequency";
import { PrefillRadioGroup } from "../../../../../components/input";
import { createOption } from "../../../../../constants/options";
import { FIELD_NAMES } from "../../../../../constants/commonConstants";

export const RepaymentAmount = ({loanAmountFieldName = FIELD_NAMES.LOAN_AMOUNT}) => {
  const repaymentFrequency = useRepaymentFrequency();
  const repaymentAmounts = useRepaymentHelper(loanAmountFieldName);

  return (
    <PrefillRadioGroup
      title={`Choose a preferred ${repaymentFrequency} repayment option for the loan amount you have selected`}
      name={name}
      defaultSelectionIndex={1}
      options={
        repaymentAmounts.map((repaymentAmountOption) =>
          createOption(`$ ${repaymentAmountOption}`, `${repaymentAmountOption}`))
      }
    />
  );
};